import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BcmService } from '@modules/bcm/bcm.service';
import { BcmBaseFacade } from '../bcm-base.facade';
import { ConfirmDialogService } from '@sharedComponents/dialogs/confirm-dialog/confirm-dialog.service';
import { BcmUserPermission } from '@modules/bcm/bcm-user-permission';
import { BcmExportExcelApiService } from '@bcmApiServices/bcm-export-excel.api-service';
import { IProduct, Product } from '@shared/models/product';
import { AppNotificationService } from '@core/services/app-notification.service';
import { productsTableData } from '@modules/bcm/@core/state-management/products/products-table-data';
import { BcmNavigationService } from '@modules/bcm/bcm-navigation.service';
import { ThemePalette } from '@angular/material/core';
import { BcmUserSettingsFacade } from '@bcmServices/settings/bcm-user-settings-facade';
import { BcmTenantPermission } from '@modules/bcm/bcm-tenant-permission';

@Injectable({providedIn: 'root'})
export class ProductsFacade extends BcmBaseFacade<Product, IProduct> {

    readonly resourcePath = 'products';

    readonly resourceNameSingular = 'Produkt';

    readonly resourceNamePlural = 'Produkte';

    readonly resourceIconPlural = 'shopping_basket';

    readonly resourceIconSingular = 'shopping_basket';

    readonly deletePermission = BcmUserPermission.PRODUCTS_DELETE;

    readonly readPermission = BcmUserPermission.PRODUCTS_READ;

    readonly writePermission = BcmUserPermission.PRODUCTS_WRITE;

    readonly headerActions = [
        {
            title: 'Excel Export',
            onClick: () => this._bcmExportExcelApiService.exportProducts(),
            tenantPermissions: [BcmTenantPermission.REPORTS],
        },
    ];

    readonly rowActions = [
        {
            title: 'Datensatz anzeigen',
            icon: 'assignment',
            iconColor: 'accent' as ThemePalette,
            onClick: (product: Product) => this._bcmNavigationService.navigate('products/' + product.id),
        },
        {
            title: 'Datensatz löschen',
            icon: 'delete',
            iconColor: 'warn' as ThemePalette,
            onClick: (product: Product) => super.remove(product, product.name).subscribe(),
        }
    ];

    constructor(appNotificationService: AppNotificationService,
                confirmDialogService: ConfirmDialogService,
                bcmUserSettingsFacade: BcmUserSettingsFacade,
                httpClient: HttpClient,
                bcmService: BcmService,
                private _bcmExportExcelApiService: BcmExportExcelApiService,
                protected _bcmNavigationService: BcmNavigationService
    ) {
        super(
            Product,
            productsTableData,
            _bcmNavigationService,
            appNotificationService,
            confirmDialogService,
            bcmUserSettingsFacade,
            httpClient,
            bcmService
        );
    }

}
